import React from 'react';

import {Box} from '@mui/material';
import {noop} from 'lodash';
import {useTranslation} from 'react-i18next';

import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import MdkModal from '@/app/shared-components/MdkModal/MdkModal';
import {COLORS} from '@/styles/colors';

import CardThemesCarousel from '../CardThemesCarousel/CardThemesCarousel';

import './styles';

interface ConfirmCardThemeModalProps {
  open: boolean;
  onClose: () => void;
  onCardThemeSelected: (cardTheme: string) => void;
}

const ChangeCardThemeModal: React.FC<ConfirmCardThemeModalProps> = ({
  open,
  onClose = noop,
  onCardThemeSelected = noop,
}) => {
  const {t} = useTranslation();

  return (
    <MdkModal
      open={open}
      onClose={onClose}
      isBottomSheet
      aria-labelledby="change-card-theme-modal">
      <Box className="change-card-theme-modal-container">
        <ChangeTextWithColorAndImage
          text={`${t('select_category_card_theme.title1')} <${COLORS.ELECTRIC_VIOLET};${t('select_category_card_theme.title2')}> ${t('select_category_card_theme.title3')}`}
          textStyle={{
            color: COLORS.ON_SURFACE,
            fontSize: 22,
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: -0.22,
          }}
        />

        {/* Category Cards Section */}
        <CardThemesCarousel onCardThemeSelected={onCardThemeSelected} />
      </Box>
    </MdkModal>
  );
};

export default ChangeCardThemeModal;
